/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerProbabilities.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Probabilities
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 03:55:55 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    PROBABILITY_LIST_CONTAINER_LOADED,
    PROBABILITY_LIST_CONTAINER_UNLOADED,
    PROBABILITY_LIST_TABLE_LOADED,
    PROBABILITY_LIST_TABLE_UNLOADED,

    PROBABILITY_SELECT_ROW,
    PROBABILITY_ADD,
    PROBABILITY_EDIT,
    PROBABILITY_DELETE,
    PROBABILITY_OPEN_WARNING,
    PROBABILITY_CLOSE_WARNING,
    
    PROBABILITY_EDIT_CONTAINER_LOADED,
    PROBABILITY_EDIT_CONTAINER_UNLOADED,
    PROBABILITY_EDIT_FORM_LOADED,
    PROBABILITY_EDIT_FORM_UNLOADED,
    PROBABILITY_EDIT_DATA_LOAD,
    PROBABILITY_EDIT_CONTAINER_SUBMIT,
    PROBABILITY_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeProbabilities';

const defaultState = {
    refreshList: false,
    danger: false,
    probabilityid: 0,
    score: '',
    operational: '',
    application: '',
    environment: '',
    color: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case PROBABILITY_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                probabilities: action.payload[0] ? action.payload[0].records : null
            }
        case PROBABILITY_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case PROBABILITY_SELECT_ROW:
            return {
                ...state,
                probabilityid: action.id
            }
        case PROBABILITY_ADD:
            return {
                ...state
            }
        case PROBABILITY_EDIT:
            return {
                ...state,
                probabilityid: action.id
            }
        case PROBABILITY_DELETE:
            return {
                ...state,
                probabilityid: null
            }
        case PROBABILITY_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case PROBABILITY_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case PROBABILITY_EDIT_CONTAINER_LOADED:
        case PROBABILITY_EDIT_DATA_LOAD:
            return {
                ...state,
                probabilityid: action.payload[0] ? action.payload[0].probabilityid : 0,
                score: action.payload[0] ? action.payload[0].score : '',
                operational: action.payload[0] ? action.payload[0].operational : '',
                application: action.payload[0] ? action.payload[0].application : '',
                environment: action.payload[0] ? action.payload[0].environment : '',
                color: action.payload[0] ? action.payload[0].color : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case PROBABILITY_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case PROBABILITY_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case PROBABILITY_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case PROBABILITY_LIST_CONTAINER_UNLOADED:
        case PROBABILITY_LIST_TABLE_UNLOADED:
        case PROBABILITY_EDIT_CONTAINER_UNLOADED:
        case PROBABILITY_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerProbabilities.js